export enum SwiperTypeEnum {
  SINGLE_PAGE = 'single_page',
  PRODUCT_CARD = 'product_card'
}
